import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { useAPI } from '@providers/useAPI';
import { useMutation } from '@tanstack/react-query';
import { AdminService } from 'app/API';
import { ApiCallError } from 'app/http/ApiCallError';
import { getApiCallErrorMessage } from 'app/http/getApiCallErrorMessage';
import { useState } from 'react';

type TProps = {
  organizationId: string;
  organizationName: string;
  onCancel: () => void;
  onSuccess: () => void;
};

export const AdminLeaveOrganizationModal = ({ organizationId, organizationName, onCancel, onSuccess }: TProps) => {
  const { call } = useAPI();
  const [error, setError] = useState<string | null>(null);

  const leaveMutation = useMutation({
    mutationFn: () => call(() => AdminService.removeSelfFromOrganization({ oid: organizationId })),
    onSuccess: (data) => {
      if (data?.error) {
        setError(data.error);
        return;
      }
      onSuccess();
    },
    onError: (mutationError) => {
      setError(mutationError instanceof ApiCallError ? getApiCallErrorMessage(mutationError) : 'Something went wrong.');
    },
  });

  const deleteHandler = () => {
    setError(null);
    leaveMutation.mutate();
  };

  return (
    <ModalWrapper width="390px">
      <ModalTitle>Confirm</ModalTitle>
      {leaveMutation.isPending ? <AbsoluteSpinner overlay={true} /> : null}
      <div className="text-center">
        Are you sure you want to remove yourself from {organizationName}? <br />
        Your assigned Jobs in this Organization will become unassigned.
      </div>
      {error && <div className="-mt-5 text-center text-[10px] font-medium text-[#ff2f2f]">{error}</div>}
      <div className="flex justify-between">
        <OutlinedButton onClick={onCancel} style={{ width: '130px' }}>
          Cancel
        </OutlinedButton>
        <Button onClick={deleteHandler} disabled={leaveMutation.isPending} style={{ width: '130px' }}>
          Delete
        </Button>
      </div>
    </ModalWrapper>
  );
};
